<footer>
  <mat-divider></mat-divider>
  <div [ngClass]="{
    'container-xlarge': isXLarge(),
    'container-large': isLarge(),
    'container-medium': isMedium(),
    'container-small': isSmall(),
    'container-xsmall': isXSmall()
  }">
    <div [ngClass]="{
      'container-column-xlarge': isXLarge(),
      'container-column-large': isLarge(),
      'container-column-medium': isMedium(),
      'container-column-small': isSmall(),
      'container-column-xsmall': isXSmall()
    }" >
    
      <span><a href="/"><img class="planetvg-banner" src="/assets/img/planetvg-banner.png"  alt="planetvg-banner"/></a></span>
      <span [ngClass]="{
        'mat-headline-6 container-partner-slogan-xlarge': isXLarge(),
        'mat-headline-6 container-partner-slogan-large': isLarge(),
        'mat-headline-6 container-partner-slogan-medium': isMedium(),
        'mat-headline-6 container-partner-slogan-small': isSmall(),
        'mat-headline-6 container-partner-slogan-xsmall': isXSmall()
      }">The vegan loyalty platform to grow sustainably</span>
    </div>
    <div [ngClass]="{
      'container-column-xlarge': isXLarge(),
      'container-column-large': isLarge(),
      'container-column-medium': isMedium(),
      'container-column-small': isSmall(),
      'container-column-xsmall': isXSmall()
    }">
      <span class="mat-headline-6">Customer Apps</span>
      <span><a href="https://play.google.com/store/apps/details?id=com.almostlevel5.planetvg.loyalty" target="_blank" rel="noopener"><img class="app-store-icon" src="/assets/img/google-play-badge.png" alt="Planet VG App - Google Play Store"></a></span>      
      <span><a href="https://apps.apple.com/app/planet-vg/id6505109649" target="_blank" rel="noopener"><img class="app-store-icon" src="/assets/img/apple-app-store-badge.png" alt="Planet VG App - Apple App Store"></a></span>
    </div>
    <div [ngClass]="{
      'container-column-xlarge': isXLarge(),
      'container-column-large': isLarge(),
      'container-column-medium': isMedium(),
      'container-column-small': isSmall(),
      'container-column-xsmall': isXSmall()
    }">
      <span class="mat-headline-6">Store Apps</span>
      <span><a href="https://play.google.com/store/apps/details?id=com.almostlevel5.planetvg.loyalty.store" target="_blank" rel="noopener"><img class="app-store-icon" src="/assets/img/google-play-badge.png" alt="Planet VG Store App - Google Play Store"></a></span>
      <span><a href="https://apps.apple.com/app/planet-vg-store/id6505109752" target="_blank" rel="noopener"><img class="app-store-icon" src="/assets/img/apple-app-store-badge.png" alt="Planet VG Store App - Apple App Store"></a></span>
    </div>
    <div [ngClass]="{
      'container-column-xlarge': isXLarge(),
      'container-column-large': isLarge(),
      'container-column-medium': isMedium(),
      'container-column-small': isSmall(),
      'container-column-xsmall': isXSmall()
    }">
    <span class="mat-headline-6">Resources</span>
    <span><a href="#" mat-button routerLink="/customer-stories">Customer Stories</a></span>
    <span><a href="#" mat-button routerLink="/faq">Frequenty Asked Questions</a></span>
    <span><a href="#" mat-button routerLink="/help-center">Help Center</a></span>
    <span><a href="#" mat-button routerLink="/accessibility">Accessibility</a></span>
    
    </div>
    <div [ngClass]="{
      'container-column-xlarge': isXLarge(),
      'container-column-large': isLarge(),
      'container-column-medium': isMedium(),
      'container-column-small': isSmall(),
      'container-column-xsmall': isXSmall()
    }">
      <span class="mat-headline-6">Legal</span>
      <span><a href="" mat-button routerLink="/user-terms">User Terms</a></span>
      <span><a href="" mat-button routerLink="/partner-terms">Partner Terms</a></span>
      <span><a href="" mat-button routerLink="/privacy-policy">Privacy Policy</a></span>
      <span><a href="" mat-button routerLink="/data-processing-agreement">Data Processing Agreement</a></span>
    </div>
    <div [ngClass]="{
      'container-column-xlarge': isXLarge(),
      'container-column-large': isLarge(),
      'container-column-medium': isMedium(),
      'container-column-small': isSmall(),
      'container-column-xsmall': isXSmall()
    }">
      <span class="mat-headline-6">Company</span>
      <span><a href="#" mat-button routerLink="/about">About</a></span>
      <span><a href="#" mat-button routerLink="/climate-pledge">Climate Pledge</a></span>
      <span><a href="https://i.planet.vg/press-kit" mat-button>Media</a></span>
      <span><a href="#" mat-button routerLink="/shout-outs">Shout Outs</a></span>
      <span><a href="#" mat-button routerLink="/contact">Contact Us</a></span>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div [ngClass]="{
    'container-trademarks-xlarge': isXLarge(),
    'container-trademarks-large': isLarge(),
    'container-trademarks-medium': isMedium(),
    'container-trademarks-small': isSmall(),
    'container-trademarks-xsmall': isXSmall()
  }" >
    <span>©️ {{ currentYear }} <a href="https://almostlevel5.com">Almost Level 5 B.V.</a> All rights reserved. Planet VG is a registered trademark licensed to Almost Level 5 B.V., registered in the Netherlands and other countries.</span>
  </div>
</footer>
